import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48ae486f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("自动接单")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("先派单再抢单")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("抢单")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "end_span" }, "分钟", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "end_span" }, "分钟", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "end_span" }, "分钟", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "立刻", -1))
const _hoisted_11 = { class: "start_span" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "end_span" }, "分钟", -1))
const _hoisted_13 = {
  slot: "footer",
  class: "dialog-footer"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取 消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_title, { title: "被动任务管理" }),
    _createVNode(_component_el_table, {
      data: $setup.tableData,
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "任务类型"
        }),
        _createVNode(_component_el_table_column, { label: "显示名称" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.store_task_pasv.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "推送职务" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString($setup.showZW(scope.row.store_task_pasv.station_id)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "任务分配模式" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.store_task_pasv.allot_mode==1?'抢单':'') + _toDisplayString(scope.row.store_task_pasv.allot_mode==2?'派单':'') + _toDisplayString(scope.row.store_task_pasv.allot_mode==3?'自动接单':''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "单次接单时效（分钟）" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.store_task_pasv.allot_mode==3?'':scope.row.store_task_pasv.accept_duration), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "抢单推送次数" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.store_task_pasv.allot_mode==3?'':scope.row.store_task_pasv.grab_number), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "任务完成时效" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.store_task_pasv.task_duration), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "任务触发" }, {
          default: _withCtx((scope) => [
            (scope.row.store_task_pasv.trigger_duration==0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "立刻"))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.name=='开房巡回'?'开房后':'') + _toDisplayString(scope.row.name=='餐后巡回'?'出餐后':'') + _toDisplayString(scope.row.name=='关房清包'?'关房后':'') + _toDisplayString(scope.row.store_task_pasv.trigger_duration) + "分钟", 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "接单兜底人员" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString($setup.showPEO(scope.row.store_task_pasv.last_user_id)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              onClick: ($event: any) => ($setup.showEdit(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      title: "任务管理",
      modelValue: $setup.dialogs,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.dialogs) = $event)),
      onClose: _cache[9] || (_cache[9] = ($event: any) => ($setup.dialogs=false)),
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: $setup.form,
          "label-position": "left",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "任务类型：" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString($setup.form.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "推送职务" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: $setup.form.zw,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.zw) = $event)),
                  placeholder: "请选择",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gwArr, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "任务分配模式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: $setup.form.allot_mode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.allot_mode) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            ($setup.form.allot_mode != 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "单次接单时效：",
                  class: "item_flex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.form.accept_duration,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.accept_duration) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.form.allot_mode != 3)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "抢单推送次数：",
                  class: "item_flex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.form.grab_number,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.grab_number) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "任务完成时效：",
              class: "item_flex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.form.task_duration,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.task_duration) = $event)),
                  type: "number"
                }, null, 8, ["modelValue"]),
                _hoisted_9
              ]),
              _: 1
            }),
            ($setup.form.name=='出餐' || $setup.form.name=='服务铃')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "任务触发："
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "任务触发：",
                  class: "item_flex"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString($setup.form.name=='开房巡回'?'开房后':'') + _toDisplayString($setup.form.name=='餐后巡回'?'出餐后':'') + _toDisplayString($setup.form.name=='关房清包'?'关房后':''), 1),
                    _createVNode(_component_el_input, {
                      modelValue: $setup.form.trigger_duration,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.trigger_duration) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_12
                  ]),
                  _: 1
                })),
            _createVNode(_component_el_form_item, { label: "接单兜底人员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: $setup.form.jd,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.jd) = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.peoArr, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.user_id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: $setup.queryClick
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.dialogs=false))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}